// ── Shared color mapping utilities ──────────────────────────────────────────
// Central home for status → color and priority → color mappings.
// Never define local getStatusColor / getPriorityColor functions — import here.

/**
 * Map a task/assignment status to a CSS hex color.
 * @param {"open"|"in_progress"|"active"|"completed"|"declined"|"blocked"|"deferred"} status
 * @returns {string} CSS hex color
 */
export function getStatusColor(status) {
  switch (status) {
    case 'completed': return '#10B981';
    case 'declined':  return '#EF4444';
    case 'blocked':   return '#EF4444';
    case 'active':
    case 'in_progress': return '#2C5FA8';
    case 'deferred':  return '#9CA3AF';
    case 'open':
    default:          return '#6B7280';
  }
}

/**
 * Map a priority level to a CSS hex color.
 * @param {"critical"|"high"|"medium"|"low"} priority
 * @returns {string} CSS hex color
 */
export function getPriorityColor(priority) {
  switch (priority) {
    case 'critical': return '#EF4444';
    case 'high':     return '#F59E0B';
    case 'medium':   return '#2C5FA8';
    case 'low':
    default:         return '#10B981';
  }
}

/**
 * Map a priority level to Tailwind class strings for backgrounds/text.
 * @param {"critical"|"high"|"medium"|"low"} priority
 * @returns {string} Tailwind classes
 */
export function getPriorityClasses(priority) {
  switch (priority) {
    case 'critical': return 'bg-red-critical/10 text-red-critical';
    case 'high':     return 'bg-yellow-nn/10 text-yellow-nn';
    case 'medium':   return 'bg-royal/10 text-royal';
    case 'low':
    default:         return 'bg-green-nn/10 text-green-nn';
  }
}

/**
 * Map an alert level to Tailwind row-tint classes (for table rows, cards, etc.).
 * @param {"critical"|"warning"|"ok"|"none"|null} level
 * @returns {string} Tailwind classes (empty string for none/ok)
 */
export function getAlertClasses(level) {
  switch (level) {
    case 'critical': return 'bg-[var(--red-bg)]';
    case 'warning':  return 'bg-[var(--yellow-bg)]';
    case 'ok':
    case 'none':
    default:         return '';
  }
}
